(function () {
  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // ── Reveal on scroll ──────────────────────────────────────────────────────
  const revealElements = document.querySelectorAll(".reveal");
  if (!prefersReducedMotion && revealElements.length) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.16 }
    );
    revealElements.forEach((item) => observer.observe(item));
  } else {
    revealElements.forEach((item) => item.classList.add("in"));
  }

  // ── Animated counters ─────────────────────────────────────────────────────
  const counters = document.querySelectorAll("[data-count-to]");
  const animateCounter = (counter) => {
    const target = Number(counter.getAttribute("data-count-to")) || 0;
    const suffix = counter.getAttribute("data-count-suffix") || "";
    const duration = 1000;
    const start = performance.now();

    const tick = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      counter.textContent = Math.round(target * eased) + suffix;
      if (progress < 1) {
        requestAnimationFrame(tick);
      }
    };

    requestAnimationFrame(tick);
  };

  if (counters.length) {
    const counterObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }
          animateCounter(entry.target);
          counterObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.55 }
    );

    counters.forEach((counter) => counterObserver.observe(counter));
  }

  // ── Tilt effect ───────────────────────────────────────────────────────────
  const tiltElements = document.querySelectorAll("[data-tilt]");
  if (!prefersReducedMotion && tiltElements.length) {
    tiltElements.forEach((card) => {
      card.addEventListener("mousemove", (event) => {
        const rect = card.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;
        const rotateY = ((x / rect.width) - 0.5) * 8;
        const rotateX = (0.5 - (y / rect.height)) * 8;
        card.style.transform = `perspective(1000px) rotateX(${rotateX.toFixed(2)}deg) rotateY(${rotateY.toFixed(2)}deg)`;
      });

      card.addEventListener("mouseleave", () => {
        card.style.transform = "perspective(1000px) rotateX(0deg) rotateY(0deg)";
      });
    });
  }

  // ── FAQ accordion ─────────────────────────────────────────────────────────
  const faqButtons = document.querySelectorAll("[data-faq-toggle]");
  faqButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const targetId = button.getAttribute("data-faq-toggle");
      const panel = targetId ? document.getElementById(targetId) : null;
      const isExpanded = button.getAttribute("aria-expanded") === "true";
      if (!panel) {
        return;
      }

      button.setAttribute("aria-expanded", String(!isExpanded));
      const marker = button.querySelector(".plus");
      if (marker) {
        marker.textContent = isExpanded ? "+" : "-";
      }

      if (isExpanded) {
        panel.style.maxHeight = "0px";
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  });

  // ── FAQ anchor auto-open ──────────────────────────────────────────────────
  // If the URL contains a #faq-* hash, scroll to the section AND
  // open the first question in that category automatically.
  (function () {
    const hash = window.location.hash;
    if (!hash) return;

    const target = document.querySelector(hash);
    if (!target) return;

    // Slight delay to let the page fully render
    setTimeout(function () {
      target.scrollIntoView({ behavior: "smooth", block: "start" });

      // Auto-open first accordion in that section
      const firstBtn = target.querySelector("[data-faq-toggle]");
      if (firstBtn && firstBtn.getAttribute("aria-expanded") === "false") {
        firstBtn.click();
      }
    }, 300);
  })();

  // ── FAQ sticky nav — highlight active section on scroll ───────────────────
  (function () {
    const faqNavLinks = document.querySelectorAll(".faq-nav-link");
    const faqSections = document.querySelectorAll(".faq-category");
    if (!faqNavLinks.length || !faqSections.length) return;

    const activate = (id) => {
      faqNavLinks.forEach((link) => {
        const matches = link.getAttribute("href") === "#" + id ||
                        link.getAttribute("href").endsWith("#" + id);
        link.classList.toggle("active", matches);
      });
    };

    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            activate(entry.target.id);
          }
        });
      },
      { rootMargin: "-20% 0px -60% 0px", threshold: 0 }
    );

    faqSections.forEach((sec) => sectionObserver.observe(sec));
  })();

  // ── Mobile hamburger menu ─────────────────────────────────────────────────
  (function () {
    var btn  = document.getElementById('navHamburger');
    var menu = document.getElementById('mobileNav');
    if (!btn || !menu) return;

    function openMenu() {
      menu.classList.add('is-open');
      btn.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      menu.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
      menu.classList.remove('is-open');
      btn.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      menu.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    btn.addEventListener('click', function () {
      btn.getAttribute('aria-expanded') === 'true' ? closeMenu() : openMenu();
    });

    // Close when a link inside the drawer is tapped
    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });

    // Close on tap outside
    document.addEventListener('click', function (e) {
      if (menu.classList.contains('is-open') && !e.target.closest('#mobileNav') && !e.target.closest('#navHamburger')) {
        closeMenu();
      }
    });

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) closeMenu();
    });
  })();

  // ── Nav dropdown — click arrow to toggle, click outside to close ─────────
  // The FAQ link itself still navigates; only the arrow button toggles the menu.
  (function () {
    const dropdowns = document.querySelectorAll('.nav-dropdown');

    dropdowns.forEach(function (dd) {
      const arrowBtn = dd.querySelector('.nav-arrow-btn');
      const menu     = dd.querySelector('.nav-dropdown-menu');
      if (!arrowBtn || !menu) return;

      function openMenu() {
        dd.classList.add('is-open');
        arrowBtn.setAttribute('aria-expanded', 'true');
      }

      function closeMenu() {
        dd.classList.remove('is-open');
        arrowBtn.setAttribute('aria-expanded', 'false');
      }

      function toggleMenu(e) {
        e.preventDefault();
        e.stopPropagation();
        dd.classList.contains('is-open') ? closeMenu() : openMenu();
      }

      // Arrow button toggles on click
      arrowBtn.addEventListener('click', toggleMenu);

      // Keep open while mouse is anywhere inside the dropdown wrapper
      // (trigger row OR the menu itself)
      dd.addEventListener('mouseleave', function () {
        closeMenu();
      });

      dd.addEventListener('mouseenter', function () {
        openMenu();
      });

      // Close when a menu item is clicked (navigation will follow href)
      menu.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          closeMenu();
        });
      });
    });

    // Close all dropdowns when clicking anywhere outside
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.nav-dropdown')) {
        document.querySelectorAll('.nav-dropdown').forEach(function (dd) {
          dd.classList.remove('is-open');
          const btn = dd.querySelector('.nav-arrow-btn');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        });
      }
    });

    // Keyboard: Escape closes open dropdown
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.nav-dropdown.is-open').forEach(function (dd) {
          dd.classList.remove('is-open');
          const btn = dd.querySelector('.nav-arrow-btn');
          if (btn) { btn.setAttribute('aria-expanded', 'false'); btn.focus(); }
        });
      }
    });
  })();

  // ── Hitch selector (homepage) ─────────────────────────────────────────────
  const selectorRoot = document.querySelector("[data-hitch-selector]");
  if (selectorRoot) {
    const selectorForm = selectorRoot.querySelector("[data-selector-form]");
    const selectorResults = selectorRoot.querySelector("[data-selector-results]");
    const selectorFields = selectorRoot.querySelectorAll("[data-selector-field]");

    // Single product — Liberty Core Adjustable Hitch only
    const options = [
      {
        name: "Liberty Core Adjustable Hitch",
        capacity: "Up to 10,000 lb GTW / 1,000 lb TW",
        receivers: ["2", "2.5", "3"],
        drops: ["2", "4", "6", "8"],
        bestFor: "Fits most trucks, SUVs, and tow vehicles. Adjustable drop and rise — one hitch handles multiple trailers.",
        link: "/collections/all"
      }
    ];

    const renderSelector = () => {
      if (!selectorForm || !selectorResults) {
        return;
      }

      const picks = {
        receiver: selectorForm.receiver ? selectorForm.receiver.value : "2",
        drop: selectorForm.drop ? selectorForm.drop.value : "2"
      };

      // Single product — always show it
      const ranked = options.slice(0, 1);

      selectorResults.innerHTML = "<div class=\"selector-cards\">" + ranked.map((item) => {
        return (
          "<article class=\"selector-card\">" +
            "<h4>" + item.name + "</h4>" +
            "<p>" + item.bestFor + "</p>" +
            "<div class=\"selector-meta\"><div><strong>Capacity:</strong> " + item.capacity + "</div></div>" +
            "<div class=\"selector-actions\">" +
              "<a class=\"btn btn-primary\" href=\"" + item.link + "\">View Options</a>" +
              "<a class=\"btn btn-secondary\" href=\"/pages/hitch-height-guide\">Measurement Guide</a>" +
              "<a class=\"btn btn-secondary\" href=\"/pages/contact\">Fitment Help</a>" +
            "</div>" +
          "</article>"
        );
      }).join("") + "</div>";
    };

    if (selectorForm) {
      selectorForm.addEventListener("submit", (event) => {
        event.preventDefault();
        renderSelector();
      });
    }

    selectorFields.forEach((field) => {
      field.addEventListener("change", renderSelector);
    });

    renderSelector();
  }
})();
